// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file password_reset.proto (package sextante.cuenta.passwordreset.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file password_reset.proto.
 */
export const file_password_reset: GenFile = /*@__PURE__*/
  fileDesc("ChRwYXNzd29yZF9yZXNldC5wcm90bxIgc2V4dGFudGUuY3VlbnRhLnBhc3N3b3JkcmVzZXQudjEiHwoOT2x2aWRhclJlcXVlc3QSDQoFZW1haWwYASABKAkiEQoPT2x2aWRhclJlc3BvbnNlIjcKFlZlcmlmaWNhckNvZGlnb1JlcXVlc3QSDQoFZW1haWwYASABKAkSDgoGY29kaWdvGAIgASgJIkEKF1ZlcmlmaWNhckNvZGlnb1Jlc3BvbnNlEhMKC3Jlc2V0X3Rva2VuGAEgASgJEhEKCWV4cGlyYV9lbhgCIAEoAyI7ChJSZXN0YWJsZWNlclJlcXVlc3QSEwoLcmVzZXRfdG9rZW4YASABKAkSEAoIcGFzc3dvcmQYAiABKAkiFQoTUmVzdGFibGVjZXJSZXNwb25zZTKLAwoUUGFzc3dvcmRSZXNldFNlcnZpY2USbgoHT2x2aWRhchIwLnNleHRhbnRlLmN1ZW50YS5wYXNzd29yZHJlc2V0LnYxLk9sdmlkYXJSZXF1ZXN0GjEuc2V4dGFudGUuY3VlbnRhLnBhc3N3b3JkcmVzZXQudjEuT2x2aWRhclJlc3BvbnNlEoYBCg9WZXJpZmljYXJDb2RpZ28SOC5zZXh0YW50ZS5jdWVudGEucGFzc3dvcmRyZXNldC52MS5WZXJpZmljYXJDb2RpZ29SZXF1ZXN0Gjkuc2V4dGFudGUuY3VlbnRhLnBhc3N3b3JkcmVzZXQudjEuVmVyaWZpY2FyQ29kaWdvUmVzcG9uc2USegoLUmVzdGFibGVjZXISNC5zZXh0YW50ZS5jdWVudGEucGFzc3dvcmRyZXNldC52MS5SZXN0YWJsZWNlclJlcXVlc3QaNS5zZXh0YW50ZS5jdWVudGEucGFzc3dvcmRyZXNldC52MS5SZXN0YWJsZWNlclJlc3BvbnNlQguqAghBcGkuR3JwY2IGcHJvdG8z");

/**
 * Email de la cuenta.
 *
 * @generated from message sextante.cuenta.passwordreset.v1.OlvidarRequest
 */
export type OlvidarRequest = Message<"sextante.cuenta.passwordreset.v1.OlvidarRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message sextante.cuenta.passwordreset.v1.OlvidarRequest.
 * Use `create(OlvidarRequestSchema)` to create a new message.
 */
export const OlvidarRequestSchema: GenMessage<OlvidarRequest> = /*@__PURE__*/
  messageDesc(file_password_reset, 0);

/**
 * Sin datos: que el rpc no falle ya indica que se mando el codigo.
 *
 * @generated from message sextante.cuenta.passwordreset.v1.OlvidarResponse
 */
export type OlvidarResponse = Message<"sextante.cuenta.passwordreset.v1.OlvidarResponse"> & {
};

/**
 * Describes the message sextante.cuenta.passwordreset.v1.OlvidarResponse.
 * Use `create(OlvidarResponseSchema)` to create a new message.
 */
export const OlvidarResponseSchema: GenMessage<OlvidarResponse> = /*@__PURE__*/
  messageDesc(file_password_reset, 1);

/**
 * Email y codigo recibido por correo.
 *
 * @generated from message sextante.cuenta.passwordreset.v1.VerificarCodigoRequest
 */
export type VerificarCodigoRequest = Message<"sextante.cuenta.passwordreset.v1.VerificarCodigoRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string codigo = 2;
   */
  codigo: string;
};

/**
 * Describes the message sextante.cuenta.passwordreset.v1.VerificarCodigoRequest.
 * Use `create(VerificarCodigoRequestSchema)` to create a new message.
 */
export const VerificarCodigoRequestSchema: GenMessage<VerificarCodigoRequest> = /*@__PURE__*/
  messageDesc(file_password_reset, 2);

/**
 * Token para el paso 3.
 *
 * @generated from message sextante.cuenta.passwordreset.v1.VerificarCodigoResponse
 */
export type VerificarCodigoResponse = Message<"sextante.cuenta.passwordreset.v1.VerificarCodigoResponse"> & {
  /**
   * @generated from field: string reset_token = 1;
   */
  resetToken: string;

  /**
   * Vencimiento del token, en Unix ms.
   *
   * @generated from field: int64 expira_en = 2;
   */
  expiraEn: bigint;
};

/**
 * Describes the message sextante.cuenta.passwordreset.v1.VerificarCodigoResponse.
 * Use `create(VerificarCodigoResponseSchema)` to create a new message.
 */
export const VerificarCodigoResponseSchema: GenMessage<VerificarCodigoResponse> = /*@__PURE__*/
  messageDesc(file_password_reset, 3);

/**
 * Contrasena nueva y token del paso 2.
 *
 * @generated from message sextante.cuenta.passwordreset.v1.RestablecerRequest
 */
export type RestablecerRequest = Message<"sextante.cuenta.passwordreset.v1.RestablecerRequest"> & {
  /**
   * @generated from field: string reset_token = 1;
   */
  resetToken: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message sextante.cuenta.passwordreset.v1.RestablecerRequest.
 * Use `create(RestablecerRequestSchema)` to create a new message.
 */
export const RestablecerRequestSchema: GenMessage<RestablecerRequest> = /*@__PURE__*/
  messageDesc(file_password_reset, 4);

/**
 * Sin datos: que el rpc no falle ya indica que se cambio la contrasena.
 *
 * @generated from message sextante.cuenta.passwordreset.v1.RestablecerResponse
 */
export type RestablecerResponse = Message<"sextante.cuenta.passwordreset.v1.RestablecerResponse"> & {
};

/**
 * Describes the message sextante.cuenta.passwordreset.v1.RestablecerResponse.
 * Use `create(RestablecerResponseSchema)` to create a new message.
 */
export const RestablecerResponseSchema: GenMessage<RestablecerResponse> = /*@__PURE__*/
  messageDesc(file_password_reset, 5);

/**
 * Recuperacion de contrasena ("olvide mi contrasena") de la SPA Cliente, en 3 pasos. Logica propia del
 * servicio gRPC, sin la capa vieja de servicios. Estos rpc no requieren sesion. Las dos
 * respuestas "vacias" no llevan un campo success: en gRPC que el rpc no tire
 * error ya es la senal de exito, cargar ese bool seria dato sin uso (ver
 * CLAUDE.md, seccion migracion a gRPC-Web).
 * 
 * Los codigos de error (EMAIL_INVALIDO, CODIGO_EXPIRADO, etc.) viajan en el
 * trailer "password-reset-code" del RpcException, no en el mensaje: el
 * cliente rama por codigo, nunca por texto. Ver PasswordResetGrpcService.cs.
 *
 * @generated from service sextante.cuenta.passwordreset.v1.PasswordResetService
 */
export const PasswordResetService: GenService<{
  /**
   * Paso 1: manda al email un codigo de verificacion que vence a los 15 minutos.
   *
   * @generated from rpc sextante.cuenta.passwordreset.v1.PasswordResetService.Olvidar
   */
  olvidar: {
    methodKind: "unary";
    input: typeof OlvidarRequestSchema;
    output: typeof OlvidarResponseSchema;
  },
  /**
   * Paso 2: valida el codigo y devuelve un token de un solo uso para cambiar la contrasena, que vence a los
   * 10 minutos. Admite hasta 5 intentos.
   *
   * @generated from rpc sextante.cuenta.passwordreset.v1.PasswordResetService.VerificarCodigo
   */
  verificarCodigo: {
    methodKind: "unary";
    input: typeof VerificarCodigoRequestSchema;
    output: typeof VerificarCodigoResponseSchema;
  },
  /**
   * Paso 3: cambia la contrasena con el token del paso 2, si cumple la politica de contrasenas.
   *
   * @generated from rpc sextante.cuenta.passwordreset.v1.PasswordResetService.Restablecer
   */
  restablecer: {
    methodKind: "unary";
    input: typeof RestablecerRequestSchema;
    output: typeof RestablecerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_password_reset, 0);

